import { render } from "./DialogInvalidSectionWithCoupon.vue?vue&type=template&id=bbf309ea"
import script from "./DialogInvalidSectionWithCoupon.vue?vue&type=script&lang=js"
export * from "./DialogInvalidSectionWithCoupon.vue?vue&type=script&lang=js"
script.render = render

export default script